export default "__VITE_ASSET__C1v_tLKI__"